import mutations from "./mutations";
import getters from "./getters";
import { useMessage } from "../../../composables/index";

import { DataService } from "../../../config/dataService/dataService";

const { errorMessage, successMessage } = useMessage();

const state = () => ({
  editPageState: {
    data: [],
    count: 0,
  },
  industries: [],
  jobFunctions: [],
  sectors: [],
  services: [],
  jobCategories: [],
  studyFields: [],
  cities: [],
  certificationFields: [],
  departments: [],
  allEmployeeRange: {
    items: [],
    count: 0,
  },
  allEmployeeRangeList: {
    items: [],
    count: 0,
  },
});

const actions = {
  async editPagesList({ commit }, { routePath, filters, page, itemPerPage }) {
    commit("SET_EDIT_STATE_PAGE", {
      data: [],
      count: 0,
    });
    try {
      const res = await DataService.post(`admin${routePath}/list`, {
        filters,
        pagination: {
          field: "id",
          ascending: true,
          page,
          items_per_page: itemPerPage,
        },
      });
      if (res?.data?.status) {
        commit("SET_EDIT_STATE_PAGE", res.data);
      }
    } catch (error) {
      console.error(error);
      errorMessage("Can't get Items");
    }
  },
  async addDataItem({ dispatch }, { routePath, name }) {
    try {
      const res = await DataService.post(`admin${routePath}/`, {
        name,
      });
      if (res?.data?.id) {
        dispatch("editPagesList", {
          routePath,
          filters: {},
          page: 1,
          itemPerPage: 10,
        });
        successMessage("Added Successfully");
      }
    } catch (error) {
      console.error(error);
      errorMessage("Add Item Failed");
    }
  },

  async updateDataItem({ dispatch }, { routePath, name, id }) {
    try {
      const res = await DataService.put(`admin${routePath}/${id}/`, {
        name,
      });
      if (Object.keys(res.data)?.length) {
        dispatch("editPagesList", {
          routePath,
          filters: {},
          page: 1,
          itemPerPage: 10,
        });
        successMessage("Updated Successfully");
      }
    } catch (error) {
      console.error(error);
      errorMessage("Failed to update a item");
    }
  },

  async deleteDataItem({ dispatch }, { routePath, id }) {
    try {
      const res = await DataService.delete(`admin${routePath}/${id}/`);
      if (res?.data?.status) {
        dispatch("editPagesList", {
          routePath,
          filters: {},
          page: 1,
          itemPerPage: 10,
        });
        successMessage("Deleted Successfully");
      }
    } catch (error) {
      errorMessage("Failed to delete a item");

      console.error(error);
    }
  },

  async getAllSectors({ commit }) {
    try {
      const res = await DataService.get("public/sector/list");
      const sectors = res?.data?.data || [];
      commit("SET_ALL_SECTORS", sectors);
    } catch (error) {
      console.error(error);
    }
  },
  async getAllDepartments({ commit }) {
    try {
      const res = await DataService.get("public/department/list");
      const department = res?.data?.data || [];

      commit("SET_ALL_DEPARTMENT", department);
    } catch (error) {
      console.error(error);
    }
  },
  async getAllIndustries({ commit }) {
    try {
      const res = await DataService.get("public/industry/list");
      const industry = res?.data?.data || [];
      commit("SET_ALL_INDUSTRIES", industry);
    } catch (error) {
      console.error(error);
    }
  },
  async getAllStudyFields({ commit }) {
    try {
      const res = await DataService.get("public/study-field/list");
      const studyFields = res?.data?.data || [];
      commit("SET_ALL_STUDY_FIELDS", studyFields);
    } catch (error) {
      console.error(error);
    }
  },
  async getAllCities({ commit }) {
    try {
      const res = await DataService.get("public/city/list");
      const cities = res?.data?.data || [];
      commit("SET_ALL_CITIES", cities);
    } catch (error) {
      console.error(error);
    }
  },

  async getAllJobFunctions({ commit }) {
    try {
      const res = await DataService.get("public/function/list");
      const jobFunctions = res?.data?.data || [];
      commit("SET_ALL_JOB_FUNCTIONS", jobFunctions);
    } catch (error) {
      console.error(error);
    }
  },

  async getAllJobCategories({ commit }) {
    try {
      const res = await DataService.get("public/job-post-category");
      const jobCategories = res?.data?.data || [];
      commit("SET_ALL_JOB_CATEGORIES", jobCategories);
    } catch (error) {
      console.error(error);
    }
  },
  async getAllJobCategory({ commit }) {
    try {
      const res = await DataService.get("public/category/list");
      const categories = res?.data?.data || [];
      commit("SET_ALL_CATEGORIES", categories);
    } catch (error) {
      console.error(error);
    }
  },

  async getAllCertificationField({ commit }) {
    try {
      const res = await DataService.get("public/certification-field/list");
      const certificationFields = res?.data.data || [];
      commit("SET_ALL_CERTIFICATION_FIELDS", certificationFields);
    } catch (error) {
      console.error(error);
    }
  },

  async getAllService({ commit }) {
    try {
      const res = await DataService.get("public/service/list");
      const services = res?.data.data || [];
      commit("SET_ALL_SERVICES", services);
    } catch (error) {
      console.error(error);
    }
  },

  async getAllEmployeeRange({ commit }, payload) {
    try {
      const res = await DataService.post("admin/employee-range/list", {
        pagination: {
          field: "id",
          ascending: true,
          page: payload.page,
          items_per_page: payload.items_per_page,
        },
      });
      commit("SET_ALL_EMPLOYEE_RANGE", res?.data);
    } catch (error) {
      console.error(error);
    }
  },

  async createRange({ commit }, data) {
    try {
      let res = await DataService.post(`admin/employee-range/`, {
        range_from: Number(data.range_from),
        range_to: Number(data.range_to),
      });
      commit("SET_ALL_EMPLOYEE_RANGE", res?.data);
      res?.status === 200 ? successMessage("Succesfully created range") : "";

      return res;
    } catch (err) {
      errorMessage("Something went wrong!");
      return err;
    }
  },

  async getAllRangeList({ commit }) {
    try {
      const res = await DataService.get("public/employee-range/list");
      const ranges = res?.data?.data || [];
      commit("SET_ALL_EMPLOYEE_RANGE_LIST", ranges);
    } catch (error) {
      console.error(error);
    }
  },

  async updateRange(context, data) {
    try {
      const res = await DataService.put(
        `admin/employee-range/${data.employee_range_id}/`,
        {
          range_from: data.range_from,
          range_to: Number(data.range_to),
        }
      );
      if (Object.keys(res.data)?.length) {

        successMessage("Updated Successfully");
      }
      return res;
    } catch (error) {
      console.error(error);
      errorMessage("Failed to update a item");
    }
  },
};

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state,
};
